import {
  ArrayNotEmpty,
  IsNotEmpty,
  IsString,
  IsOptional,
} from 'class-validator';

export class Reaction {
  @IsNotEmpty()
  product!: string;

  @ArrayNotEmpty()
  @IsNotEmpty({ each: true })
  substrates!: string[];

  @ArrayNotEmpty()
  @IsNotEmpty({ each: true })
  @IsOptional()
  productMap?: number[]; // FIXME: Temporarily optional

  @ArrayNotEmpty()
  @IsNotEmpty({ each: true })
  @IsOptional()
  substratesMap?: number[][]; // FIXME: Temporarily optional

  @IsString()
  @IsOptional()
  solvent?: string;
}
